import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Checkbox from "./Checkbox";
import '../index.css';
import { optionsPlan, optionsCuotas, optionsMontosOtros, montosPmi, montosPmi2000, montosPmi3000, montosPmiEntidad, montos2000Entidad, montos3000Entidad } from "../data/options";
import { Button } from "@nextui-org/react";


const Form = ({ getValues }) => {

    const [plan,setPlan] = useState('');
    const [tipo,setTipo] = useState([]);
    const [monto,setMonto] = useState('');
    const [cuotas,setCuotas] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedNot, setIsCheckedNot] = useState(false);
    const [isSubmited, setIsSubmited] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [disabledSelect, setDisabledSelect] = useState(false);

    

    useEffect(() => {
        (plan === 'Pmi' || plan === 'Pmi Soltero' || plan === 'Pmi 2000' || plan === 'Pmi 3000') ? setToggle(true) : setToggle(false);
        !(plan === 'Pmi' || plan === 'Pmi Soltero' || plan === 'Pmi 2000' || plan === 'Pmi 3000') && plan !== '' ? setIsCheckedNot(true) : setIsCheckedNot(f => f);

        const containClass = document.getElementsByClassName("css-1dimb5e-singleValue")[1];
        containClass !== undefined ? document.getElementsByClassName("css-1dimb5e-singleValue")[1].innerText = 'Elegí el monto de tu Ayuda' : console.log('notEmpty');

        isChecked ?
            (plan === 'Pmi' || plan === 'Pmi Soltero') ? setTipo(montosPmiEntidad)
                : plan === 'Pmi 2000' ? setTipo(montos2000Entidad)
                    : plan === 'Pmi 3000' ? setTipo(montos3000Entidad)
                        : setTipo(t => t) : handleChangeTipo(plan);

        isCheckedNot ? setIsChecked(false) : setIsChecked(isChecked);
        isCheckedNot ? handleChangeTipo(plan) : setIsChecked(isChecked);
        isChecked || isCheckedNot ? setDisabledSelect(false) : setDisabledSelect(t => t);
        !isChecked && !isCheckedNot ? setDisabledSelect(true) : setDisabledSelect(t => t);

    }, [isChecked, isCheckedNot, plan]);

   


    const handleOnChangeCheck = () => {
        setIsCheckedNot(false)
        setIsChecked(!isChecked);
    };

    const handleOnChangeNot = () => {
        setIsCheckedNot(!isCheckedNot);
    }

    const handleChangeTipo = (e) => {
        e !== '' ?
            (e === 'Pmi' || e === 'Pmi Soltero') ? setTipo(montosPmi)
                : e === 'Pmi 2000' ? setTipo(montosPmi2000)
                    : e === 'Pmi 3000' ? setTipo(montosPmi3000) : setTipo(optionsMontosOtros) : setTipo(t => t);
    };

    const handleChangePlan = ({ label }) => {
        setPlan(label);
        (label === 'Pmi' || label === 'Pmi Soltero') && !isChecked ? setTipo(montosPmi)
            : (label === 'Pmi 2000') && !isChecked ? setTipo(montosPmi2000)
                : label === 'Pmi 3000' && !isChecked ? setTipo(montosPmi3000) : setTipo(optionsMontosOtros)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        getValues({ plan, monto, cuotas });
        setIsSubmited(true)
    };


    return(
        <form onSubmit={handleSubmit}>
            <label className="text-small text-default-700" htmlFor="name">Plan</label>
            <Select
                options={optionsPlan}
                onChange={handleChangePlan}
                placeholder={"Seleccioná tu Plan"}
            />
            {toggle ?
                <Checkbox
                    isChecked={isChecked}
                    isCheckedNot={isCheckedNot}
                    handleOnChangeCheck={handleOnChangeCheck}
                    handleOnChangeNot={handleOnChangeNot}
                /> : <></>
            }
            <div className={"clearMin"}></div>
            <label className="text-small text-default-700" htmlFor="name">Monto</label>
            <Select
                options={tipo}
                onChange={({value}) => setMonto(value)}
                placeholder={"Elegí el monto de tu Ayuda"}
                isDisabled={disabledSelect}
            />
            <div className={"clearMin"}></div>
            <label className="text-small text-default-700" htmlFor="name">Cuotas</label>
            <Select
                options={optionsCuotas}
                onChange={({value}) => setCuotas(value)}
                placeholder={"Elegí en cuantas cuotas"}
            />
            <div className={"clearMid"}></div>
             {
                plan === ('Pmi' || 'Pmi Soltero' || 'Pmi 2000' || 'Pmi 3000') && (isChecked || isCheckedNot) && monto !== '' && cuotas !== ''
                    ? <Button type="submit" className={"btnSubmit"}>
                        Simular ahora
                    </Button> :
                plan !== ('Pmi' || 'Pmi Soltero' || 'Pmi 2000' || 'Pmi 3000') && monto !== '' && cuotas !== '' ?
                    <Button type="submit" className={"btnSubmit"}>
                        Simular ahora
                     </Button> :
                     <Button type="submit" className={"btnSubmit"} disabled>
                         Simular ahora
                     </Button>
            }
        </form>
    )
}

export default Form;

